import React from 'react';
import {connectSortBy} from 'react-instantsearch-dom';

import ChevronDown from './ChevronDown';

const CustomSortBy = ({items, refine}) => (
  <div className="ais-SortBy">
    <select className="ais-SortBy-select" onChange={event => refine(event.target.value)}>
      {items.map(item => (
        <option key={item.value} className="ais-SortBy-option" value={item.value}>
          {item.label}
        </option>
      ))}
    </select>
    <ChevronDown />
  </div>
);

const SortBy = connectSortBy(CustomSortBy);

export default SortBy;
